// extracted by mini-css-extract-plugin
export default {"notfound-content":"NotFoundPage_notfound-content__ym0sK"};